import React from "react";
import Base from "./Employee_Base.js";
import { PersonAdd, List, AccountTree, AccountBalanceWallet } from "@mui/icons-material";
import "./EmployeeDashboard.css";
import {Link} from "@mui/material";
import ReceiptIcon from '@mui/icons-material/Receipt';

const EmployeeDashboard = () => {


  return (
    <Base>
      <div className="pt-3 mt-3">
        <h2 className="text-center fw-bold fs-1 dashboard-heading" style={{ color: "darkslategrey" }}>
          Dashboard
        </h2>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <hr style={{ width: "90%" }} />
        </div>
      </div>

      <div className="pt-0  employee-main">
        <div className="dashboard-container">
          <Link href="./add_employee" style={{ textDecoration: "none" }}>
            <div className="emp-card">
              <PersonAdd className="icon" fontSize="large" />
              <h3 className="header-card">Add Employee</h3>
            </div>
          </Link>

          <Link href="./employee_list" style={{ textDecoration: "none" }}>
            <div className="emp-card" >
              <List className="icon" fontSize="large" />
              <h3 className="header-card">Employee List</h3>
            </div>
          </Link>

          <Link href="./employee_tree" style={{ textDecoration: "none" }}>
            <div className="emp-card" >
              <AccountTree className="icon" fontSize="large" />
              <h3 className="header-card">Employee Tree</h3>
            </div>
          </Link>

          <Link href="./employee_wallet_amount" style={{ textDecoration: "none" }}>
            <div className="emp-card">
              <AccountBalanceWallet className="icon" fontSize="large" />
              <h3 className="header-card">Employee Wallet</h3>
            </div>
          </Link>

          <Link href="./customer_list" style={{ textDecoration: "none" }}>
            <div className="emp-card">
              <List className="icon" fontSize="large" />
              <h3 className="header-card">Customer List</h3>
            </div>
          </Link>

          <Link href="./customer_payment_list" style={{ textDecoration: "none" }}>
            <div className="emp-card">
              <ReceiptIcon className="icon" fontSize="large" />
              <h3 className="header-card">Customer Payment List</h3>
            </div>
          </Link>

          <Link href="./employee_wallet_transcation_list" style={{ textDecoration: "none" }}>
            <div className="emp-card" id="wallet-card" >
              <AccountBalanceWallet className="icon" fontSize="large" />
              <h3 className="header-card">Employee Wallet Transcation List</h3>
            </div>
          </Link>
        </div>
      </div>
    </Base>
  );
};

export default EmployeeDashboard;
